import {
    getAsync,
    postAsync,
    putAsync,
    deleteAsync
} from "../helpers/apiHelper";

const endpoint = process.env.VUE_APP_BACKEND + "/api/AgeGroup";

// Get all AgeGroups for a discipline
export async function getAgeGroupForDisciplineAsync(disciplineId) {
  return await getAsync(`${endpoint}/getAllForDiscipline/${disciplineId}`);
}

// Create an AgeGroup for a Discipline
export async function createAgeGroupForDisciplineAsync(disciplineId, model) {
  return await postAsync(`${endpoint}/${disciplineId}`, model);
}

// Update an AgeGroup
export async function updateAgeGroupAsync(model) {
  return await putAsync(`${endpoint}/${model.id}`, model);
}

// Delete an AgeGroup
export async function deleteAgeGroupAsync(Id) {
  return await deleteAsync(`${endpoint}/${Id}`);
}